module.exports = __webpack_public_path__ + "img/c08_unitguru_Normal_ua.8e550bc5.webp";